import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type UpdateSiteApiResponse } from '../services/updateSiteService'

export interface UpdateSiteState {
  isLoading: boolean
  error: string | undefined
  data: UpdateSiteApiResponse | undefined
  httpStatus: number | undefined
}

export const initialState: UpdateSiteState = {
  isLoading: false,
  error: undefined,
  data: undefined,
  httpStatus: 0
}

const updateSiteSlice = createSlice({
  name: 'UpdateSiteSlice',
  initialState,
  reducers: {
    updateSiteLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: undefined,
        httpStatus: 0
      }
    },
    updateSiteUpdateAction: (state, action: PayloadAction<{ data: UpdateSiteApiResponse, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    updateSiteErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: undefined,
        httpStatus: action.payload.httpStatus
      }
    },
    reset: () => initialState
  }
})

export const {
  updateSiteLoadingAction,
  updateSiteUpdateAction,
  updateSiteErrorAction,
  reset
} = updateSiteSlice.actions

export default updateSiteSlice.reducer
